import SurveyModel from './SurveyModel';
import SurveyQuestionResponses from './SurveyQuestionResponses';

export default class SurveyResponse {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.interpolations = data.interpolations
    this.survey = new SurveyModel(data.survey_template)
    this.responses = new SurveyQuestionResponses(data.responses)
    this.user_id = data.user_id || 0
    this.external_id = data.external_id
  }
}
